const BLOCKHASH_ERROR_PATTERNS = [
  'blockhash not found',
  'block height exceeded',
  'expired blockhash',
];

export const isBlockhashStaleError = (message: string) => {
  const normalizedMessage = message.toLowerCase();
  return BLOCKHASH_ERROR_PATTERNS.some((pattern) =>
    normalizedMessage.includes(pattern),
  );
};

export const MAX_BLOCKHASH_RETRIES = 2;
